import dayjs from 'dayjs'

export enum DateFormat {
    SHORT = 'DD-MM-YYYY',
    MEDIUM = 'D MMM YYYY',
    LONG = 'D MMMM YYYY',
    SHORT_TIME = 'DD-MM-YYYY, HH:mm',
    SHORT_TIME_SPECIFIC = 'DD-MM-YYYY, HH:mm:ss',
    SHORT_DATE_TIME = 'DD MMM, HH:mm',
    LONG_DAY = 'dddd - D MMM YYYY',
    SHORT_DAY = 'dddd, HH:mm ',
}

/**
 * @returns a string with the date in a specified format
 * @deprecated use the toAbsoluteDate in the project you need to use this in. This version of dayjs doesn't know about the locale set in that project so will always return english.
 */
export const toAbsoluteDate = (date: Date | string, format: DateFormat = DateFormat.MEDIUM): string => {
    if (typeof date === 'string') date = new Date(date)
    if (!date?.getTime()) return ''
    return dayjs(date).format(format)
}

/**
 * Resets a date to the start of the day, preventing issues with UTC offset
 * @returns a date with zero hours, minutes, seconds and milliseconds
 */
export const toDateOnStartDay = (date: Date): Date => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0))
}
